var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconShowPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.32773 12.8234C4.10408 9.09537 7.34949 6.44645 11.0002 6.44645C14.6497 6.44645 17.8951 9.09537 18.6726 12.8234C18.7034 12.9714 18.7917 13.101 18.9181 13.1838C19.0444 13.2667 19.1985 13.2959 19.3465 13.2651C19.4944 13.2343 19.6241 13.146 19.7069 13.0196C19.7897 12.8933 19.8189 12.7392 19.7882 12.5912C18.9037 8.35089 15.2041 5.30811 11.0002 5.30811C6.79626 5.30811 3.09665 8.35089 2.21215 12.5912C2.18136 12.7392 2.21059 12.8933 2.29342 13.0196C2.37625 13.146 2.5059 13.2343 2.65383 13.2651C2.80177 13.2959 2.95587 13.2667 3.08225 13.1838C3.20864 13.101 3.29694 12.9714 3.32773 12.8234ZM10.9888 8.72313C12.0454 8.72313 13.0588 9.14289 13.806 9.89008C14.5532 10.6373 14.973 11.6507 14.973 12.7073C14.973 13.764 14.5532 14.7774 13.806 15.5246C13.0588 16.2718 12.0454 16.6915 10.9888 16.6915C9.9321 16.6915 8.9187 16.2718 8.17152 15.5246C7.42434 14.7774 7.00457 13.764 7.00457 12.7073C7.00457 11.6507 7.42434 10.6373 8.17152 9.89008C8.9187 9.14289 9.9321 8.72313 10.9888 8.72313Z",
    fill: "#6A707C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconShowPassword);
export default __webpack_public_path__ + "static/media/common_icon_show_password.ebe2f38ee8b746d505f81b83950c32ac.svg";
export { ForwardRef as ReactComponent };